import { MutationTree } from 'vuex'
import { AuctionState } from './AuctionState'
import { NotificationData } from './NotificationData'
import { PersonalData } from './PersonalData'
import { RepresentationData } from './RepresentationData'
import { StatementsData } from './StatementsData'
import { DocumentationsData } from './DocumentationsData'
import { VerificationData } from './VerificationData'
import { ResforDataDto } from '@/Application/Resfor'

export const mutations: MutationTree<AuctionState> = {
  clearAuction: (state: AuctionState) => {
    state.resforCode = ''
    state.resforNif = ''
    state.lastWizardStep = 1
    state.procesedAuctionA = false
    state.notification = {
      notificarA: '',
      movil: '',
      email: '',
      movilValid: false,
      emailValid: false
    }
    state.personalData = {
      name: '',
      firstSurname: '',
      secondSurname: '',
      nif: '',
      streetType: '',
      streetTypeName: '',
      street: '',
      streetNumber: '',
      block: '',
      floor: '',
      door: '',
      parish: '',
      parishName: '',
      place: '',
      placeName: '',
      postalCode: '',
      province: '',
      provinceName: '',
      county: '',
      countyName: '',
      local: '',
      phone: '',
      fax: '',
      mobile: '',
      email: ''
    }
    state.docOptionSelected = 0
    state.documentationsData = []
    state.verificationData = []
    state.representationData = {
      name: '',
      firstSurname: '',
      secondSurname: '',
      nif: ''
    }
    state.procedureData = []
    state.statementsData = {
      rexistro: '',
      rexistroLicitadorXeral: false,
      licitadorXeral: '',
      rexistroLicitadorOficial: false,
      licitadorOficial: '',
      discapacidade: false,
      numDiscapacidade: '',
      temporais: false,
      numTemporais: '',
      mulleres: false,
      numMulleres: '',
      option4Selected: [],
      confirm: false
    }
  },
  setNotification (state: AuctionState, payload: NotificationData) {
    state.notification = payload
  },
  setPersonalData (state: AuctionState, payload: PersonalData) {
    state.personalData = payload
  },
  setRepresentationData (state: AuctionState, payload: RepresentationData) {
    state.representationData = payload
  },
  setResforNif (state: AuctionState, payload: string) {
    state.resforNif = payload
  },
  setResforCode (state: AuctionState, payload: string) {
    state.resforCode = payload
  },
  setProcedureData (state: AuctionState, payload: string[]) {
    state.procedureData = payload
  },
  setLastWizardStep (state: AuctionState, payload: number) {
    state.lastWizardStep = payload
  },
  setProcesedAuctionA (state: AuctionState, payload: boolean) {
    state.procesedAuctionA = payload
  },
  setStatementsData (state: AuctionState, payload: StatementsData) {
    state.statementsData = payload
  },
  setDocOptionSelected (state: AuctionState, payload: number) {
    state.docOptionSelected = payload
  },
  clearDocumentationsData (state: AuctionState) {
    state.documentationsData = []
  },
  setDocumentations (state: AuctionState, payload: DocumentationsData[]) {
    state.documentationsData = payload
  },
  setVerifications (state: AuctionState, payload: VerificationData[]) {
    state.verificationData = payload
  },
  updatePersonalDataWithResforData (state: AuctionState, payload: ResforDataDto) {
    const personalData = { ...state.personalData }
    personalData.nif = payload.identityCode
    personalData.email = payload.email
    personalData.phone = payload.phone
    personalData.fax = payload.fax
    personalData.province = payload.provinceCode ? payload.provinceCode + '' : ''
    personalData.county = payload.countyCode ? payload.countyCode + '' : ''
    personalData.parish = payload.parishCode ? payload.parishCode + '' : ''
    personalData.postalCode = payload.postalCode ? payload.postalCode : ''
    personalData.local = payload.placeCode ? payload.placeCode + '' : ''
    personalData.nif = payload.identityCode ? payload.identityCode : ''
    personalData.name = payload.name ? payload.name : ''
    // state.personalData.name = payload.name
    // state.personalData.street = payload.address
    state.personalData = personalData
  }
}
